import { UseFilePickerConfig, Validator } from 'use-file-picker';
import { FileWithPath } from 'file-selector';

export const FILES_SIZE_EXCEEDED_ERROR_NAME = 'files_size_exceeded';

export class FilesSizeValidator implements Validator {
  fileSizes: number[];
  maxFilesSizeMb: number;

  constructor(fileSizes: number[], maxFilesSizeMb: number) {
    this.fileSizes = fileSizes || [];
    this.maxFilesSizeMb = maxFilesSizeMb;
  }

  async validateBeforeParsing(
    _config: UseFilePickerConfig,
    plainFiles: File[],
  ) {
    const initialFileSize = this.fileSizes.reduce((a, b) => a + b, 0);

    return new Promise<void>((res, rej) =>
      Array.from(plainFiles)
        .map((file) => file.size)
        .reduce((size1, size2) => size1 + size2) +
        initialFileSize <=
      this.maxFilesSizeMb * 1000000
        ? res()
        : rej({ name: FILES_SIZE_EXCEEDED_ERROR_NAME }),
    );
  }

  async validateAfterParsing(
    _config: UseFilePickerConfig,
    _file: FileWithPath,
    _reader: FileReader,
  ) {
    return new Promise<void>((res) => res());
  }
}
